import { MasterViewModel, WalkAndPunchApiClient } from 'src/proxy/api/walkandpunch-api.proxy';
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class NodeLevelStoreService {
  _nodeLevel$ = new BehaviorSubject<MasterViewModel[]>(null);

  constructor(private elementService: WalkAndPunchApiClient) {}

  loadNodeLevels() {
    return this.elementService.v1ElementsGetAllNodeLevelsGET();
  }

  get nodeLevel() {
    return this._nodeLevel$.value;
  }

  set nodeLevel(data: MasterViewModel[]) {
    this._nodeLevel$.next(data);
  }

  get nodeLevel$() {
    return this._nodeLevel$;
  }
}
